module.exports = __webpack_public_path__ + "static/media/story_07.b4767163.jpg";